<template>
    <div class="main partner">
        <Header :back='false'></Header>
        <div class="content">
            <div class="left">
                <div class="top">
                    <liveAnimals></liveAnimals>
                </div>
                <div class="footer">
                    <pen></pen>
                </div>
            </div>

            <div class="right">
                <div class="top">
                    <div class="info-line">
                        <div class="info" style="margin-left: 2.88rem;" @click="showModel">
                            <img src="../../assets/yq/watchbig.png" alt="">
                            <div class="text">
                                <div class="t-t">
                                    <span>监控视频</span>
                                    <img src="../../assets/yq/right-arrow.png" alt="">
                                </div>
                                <div class="t-b">
                                    <span>11</span>
                                    <span>个</span>
                                </div>
                            </div>
                        </div>
                        <div class="info" style="margin-left: 1.5rem;">
                            <img src="../../assets/yq/gatewaybig.png" alt="">
                            <div class="text">
                                <div class="t-t">
                                    <span>网关设备</span>
                                    <img src="../../assets/yq/right-arrow.png" alt="">
                                </div>
                                <div class="t-b">
                                    <span>11</span>
                                    <span>个</span>
                                </div>
                            </div>
                        </div>
                        <div class="info" style="margin-left: 1.5rem;" @click="goWarning">
                            <img src="../../assets/yq/warningbig.png" alt="">
                            <div class="text">
                                <div class="t-t">
                                    <span>预警信息</span>
                                    <img src="../../assets/yq/right-arrow.png" alt="">
                                </div>
                                <div class="t-b">
                                    <span>{{ totalNum }}</span>
                                    <span>个</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img class="img" style="top: 2.3rem;left: 3.7rem;" src="../../assets/yq/gateway.png" alt="">
                    <img class="img" style="top: 2.8rem;left: 7rem;" src="../../assets/yq/gateway.png" alt="">
                    <img class="img" style="top: 4.3rem;left: 12.5rem;" src="../../assets/yq/gateway.png" alt="">
                    <img class="img" @click="showWatch(0)" style="top: 3.5rem;left: 4.5rem;" src="../../assets/yq/watch.png"
                        alt="">
                    <img class="img" @click="showWatch(1)" style="top: 5.5rem;left: 4.2rem;" src="../../assets/yq/watch.png"
                        alt="">
                    <img class="img" @click="showWatch(2)" style="top: 2.3rem;left: 9rem;" src="../../assets/yq/watch.png"
                        alt="">
                    <img class="img" @click="showWatch(0)" style="top: 5rem;left: 9rem;" src="../../assets/yq/watch.png"
                        alt="">
                    <img class="img" @click="showWatch(1)" style="top: 3rem;left: 12rem;" src="../../assets/yq/watch.png"
                        alt="">
                    <img class="img" @click="showWatch(2)" style="top: 4rem;right: .85rem;" src="../../assets/yq/watch.png"
                        alt="">
                </div>
                <div class="footer">
                    <div class="f-l">
                        <cultivation></cultivation>
                    </div>
                    <div class="f-r">
                        <property></property>
                    </div>
                </div>
            </div>
        </div>
        <videos v-if="show" @hideClose="hideClose" />
        <foldModel v-if="shows" :dialogVisible='dialogVisible' :activeIndex='activeIndex' :videoData='watchData'>
        </foldModel>
    </div>
</template>
  
<script>
import cultivation from './components/cultivation.vue'
import property from './components/property.vue'
import liveAnimals from './components/liveAnimals.vue'
import pen from './components/pen.vue'
import videos from '../../views/yqScreen/video/index.vue'
import Header from "@/views/yqScreen/components/header.vue";

import foldModel from './components/foldModel.vue'
export default {
    components: {
        cultivation, property, liveAnimals, pen, Header, foldModel,
        videos
    },
    data() {
        return {
            showProperty: false,
            show: false,
            dialogVisible: false,
            totalNum: 0,
            deviceList: [],
            watchData: {},
            activeIndex: 0,
            shows:false
        };
    },
    watch: {},
    created() {
        this.getNumber()
    },
    mounted() {
        // 实时短信
        // this.getChangeMessage()
        this.getPasture()
    },
    // 销毁定时器
    destroyed() {
        clearInterval(this.warnTimer)
        clearInterval(this.messageTimer)
    },
    // 日期过滤
    filters: {
    },
    methods: {
        cancel(){
            this.shows=false
        },
        showWatch(index) {
            // console.log(index)
            // if(this.deviceList.length>0){
            // 	this.dialogVisible=true
            // 	this.watchData=this.deviceList[index]
            // 	this.activeIndex=index
            // }
            this.shows=true
            this.dialogVisible = true
            this.activeIndex = index

        },
        getPasture() {
            this.$http({
                url: 'screenapp-service/pastureSpace/list',
                method: 'post',
                //传递的参数
                data: {
                    userName: '17684777567' || ''
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    let pastureId = data.result[0].pastureId
                    let userPhone = data.result[0].userName
                    // 获取牧场有几个视频
                    this.getVideoList(pastureId, userPhone)
                } else {
                    // this.$message.error(data);
                }
            })
        },
        getVideoList(pastureId, userPhone) {
            this.$http({
                url: 'ffsapp-service/pasture/selectPastureVideo',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "pastureId": pastureId,
                    "userPhone": userPhone
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.deviceList = data.result.list
                    // if (this.deviceList.length > 0) {
                    //     this.command=this.deviceList[0].mountLocation
                    //     this.currentDeviceInfo = this.deviceList[0]
                    //     this.getPlayUrl()
                    // } else {
                    //     this.currentDeviceInfo = {}
                    // }
                    console.log(this.deviceList)
                } else {
                    // this.$message.error(data);
                }
            })
        },
        // 发送短信接口
        getMessage() {
            this.$http({
                url: 'screenapp-service/screenWarningInfo/tag',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "pastureId": '1647418543655018498',
                },
            }).then(res => {
                this.getNumber()
                if (res.data.code === 200) {

                } else {
                    // this.$message.error(data);
                }
            }).catch(err => {
                console.log(err);
                this.getNumber()
            })
        },
        // 获取体温预警数值
        getNumber() {
            this.$http({
                url: 'screenapp-service/screenWarningInfo/count',
                //请求方式
                method: 'post',
                //传递的参数
                data: {

                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.totalNum = Number(data.result) + Number(46)
                } else {
                    // this.$message.error(data);
                }
            })
        },
        // 实时短信
        getChangeMessage() {
            this.messageTimer = setInterval(() => {
                this.getMessage()
            }, 2000)
        },
        goWarning() {
            this.$router.push({ name: 'warning' })
        },
        showModel() {
            this.NoScrolling()
            this.show = true;
        },
        hideClose() {
            this.show = false;
        },
        // 跳转养殖户详情
        details(val) {
            console.log(val);
            // window.localStorage.setItem('MYINFO', JSON.stringify(this.breeList[val.rowIndex]))
            this.$router.push({ name: 'business' })
        },
        // 搜索
        getList() {

        },
        // 存栏品类分布
        cattleStatusBtn(val) {
            this.cattleStatus = val
            this.setBarData(this[val])
        },
        // 产犊趋势图
        serviceStatusBtn(val) {
            this.serviceStatus = val
            this.setLineData(this[val], 'lineChart')
        },
        // 产绒量
        velvetBtn(val) {
            this.velvetStatus = val
        },
        setLineData(data, dom) {
            const colors = ['#19ECFF', '#2C41FE', '#40FF00'];
            const legend = [];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: '#FFFFFF' },
                    icon: 'circle',
                    itemWidth: 4,
                    itemhight: 4,
                })
                xAxis = item.month
                series.push({
                    name: item.title,
                    type: "line",
                    lineStyle: {
                        width: 2,
                    },
                    color: colors[index],
                    data: item.value,
                })
            })
            const line = {
                dom,
                xAxis,
                legend: {
                    data: legend,
                    // x: 'right',
                    // y: 'top',
                    top: "0%",
                    right: "3%",
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [10, 0, 0, 0],
                },
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            this.chart = this.$echarts.init(document.getElementById(data.dom))
            // 隐藏动画加载效果。
            var option = {
                color: ['#106BDC', '#0EDAE2', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    // formatter: function (params) {
                    //     // console.log(params, 'params');
                    //     // return `<p>
                    //     //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                    //     //     }： ${params.data.account || 0} </span>

                    //     //       </p>`;
                    //     return `
                    //     <p style="font-size: 14px; font-weight: normal;">
                    //         }</p><br/>
                    //      <p>
                    //     <p style="font-size: 14px; font-weight: normal;">
                    //         }</p><br/>
                    //      <p style="font-size: 14px; font-weight: normal;"></p><br/>
                    //      <p style="font-size: 14px; font-weight: normal;"></p>
                    //      `;
                    //     // return params.name
                    // },
                    padding: [5, 20],
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: data.legend,
                grid: {
                    top: '20%',
                    left: '5%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#19ECFF',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: data.dom == 'lineChart' ? '数量(头)' : '重量(kg)',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 45, 0, 0],
                    },
                    type: 'value',
                    splitNumber: 3,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },
                series: data.series,
            }
            this.chart.clear();
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        // 存栏柱状图
        setBarData(data) {
            var chart = this.$echarts.init(document.getElementById('barChart'))
            // 隐藏动画加载效果。
            var option = {
                title: {
                    text: '',
                    textAlign: 'left',
                    textStyle: {
                        color: '#00DAC8', // 主标题文字的颜色。
                        fontSize: 18, // 字体大小
                        lineHeight: '30', // 行高
                    },
                    triggerEvent: false, // 是否触发事件
                    x: 'center',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                    formatter: function (params) {
                        // console.log(params,'params');
                        // return `<p>
                        //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                        //     }： ${params.data.account || 0} </span>

                        //       </p>`;
                        if (params[0].name.indexOf("牛") != -1) {
                            return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].axisValue
                                }</p><br/>
                         <p>
                          <span style="font-size: 14px; font-weight: normal;">存栏数量： ${params[0].value || 0} 头 </span>
                         </p>`;
                        } else {
                            return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].axisValue
                                }</p><br/>
                         <p>
                          <span style="font-size: 14px; font-weight: normal;">存栏数量： ${params[0].value || 0} 只 </span>
                         </p>`;
                        }

                        // return params.name
                    },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: '',
                grid: {
                    top: '20%',
                    // 20
                    left: '3%',
                    right: '4%',
                    bottom: '1%',
                    // height: '150px',
                    // 130
                    // 150
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                        rotate: 30,
                        // interval: 'auto',
                        textStyle: {
                            fontSize: 12
                        },
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: 'rgba(25,236,255,1.000)',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true,
                        // interval: 0,
                        // alignWithLabel:1,
                        lineStyle: {
                            dashOffset: 5
                        },
                        // length:10
                    },
                    data: data.label,
                },
                yAxis: {
                    // name: '数量(头)',
                    name: '数量(头)',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 45, 0, 0],
                    },
                    type: 'value',
                    splitNumber: 4,
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisTick: { show: false },

                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: '#6FB6FF',
                        },
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                        textStyle: {
                            fontSize: 12
                        }
                    },
                },
                series: {
                    // name: barData.name,
                    type: 'bar',
                    barWidth: '15',
                    barGap: 0,
                    emphasis: {
                        focus: "series",
                    },
                    backgroundStyle: {
                        // color: 'rgba(44, 118, 254, 0.2)'
                        color: '#00E0DB'
                    },
                    itemStyle: {
                        opacity: 1,
                        // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        //     {
                        //         offset: 1,
                        //         color: "#297DFC",
                        //     },
                        //     {
                        //         offset: 0,
                        //         color: "#06FDF5",
                        //     },
                        // ]),
                        color: "rgba(25,236,255,1.000)"
                    },
                    data: data.value,
                },
            }

            chart.clear();
            chart.setOption(option)
            window.addEventListener('resize', () => {
                chart.resize()
            })
        },

        // 环状图
        pieChart(data, dom) {
            // var sum = 0
            // Object.values(data).forEach((item) => {
            //     return sum = sum + item
            // }, 0)
            var myChart = this.$echarts.init(document.getElementById(dom));
            var option = {
                // color: ['#0EDAE2', '#5D2CFE', '#E7C660', '#2C76FE'],
                color: ['#3AFFFB', '#7239EA', '#FFC700', '#165DFF'],
                title: {
                    show: true,
                    left: '45%',
                    top: '40%',
                    // text: `共计(家)\n\n ${sum}`,
                    text: ``,
                    textStyle: {
                        color: '#FFFFFF',
                        fontWeight: 500,
                        fontSize: 12
                    },
                },
                grid: {
                    top: '10%',
                    bottom: '20%',
                    left: 10,
                    right: 10,
                },
                tooltip: {
                    trigger: 'item',
                    axisPointer: {
                        type: 'shadow',
                    },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                    formatter: '{b} {d}%\n\n'
                },
                legend: {
                    top: '23%',
                    right: '7%',
                    icon: 'circle',
                    show: false,
                    // formatter: function (name) {
                    //     if (name == '商城交易') return `${name}  ${data.mallTrade + '%'}`
                    //     if (name == '活畜交易') return `${name}  ${data.liveTrade + '%'}`
                    //     if (name == '屠宰交易') return `${name}  ${data.slaughterTrade + '%'}`
                    // },
                    textStyle: {
                        color: '#00E0DB',
                        fontWeight: 400,
                        fontFamily: 'HarmonyOS Sans SC-Regular, HarmonyOS Sans SC'
                    },
                    orient: 'vertical',
                    itemGap: 20
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '70%'],
                        // avoidLabelOverlap: false,
                        label: {
                            show: true,
                            position: 'outside',
                            color: '#FFFFFF',
                            formatter: ' {b} {d}% \n\n',
                            padding: [0, -70],
                            alignTo: 'labelLine'
                        },
                        // emphasis: {
                        //     label: {
                        //         show: true,
                        //         // fontSize: '40',
                        //         // fontWeight: 'bold'
                        //     }
                        // },
                        labelLine: {
                            show: true,
                            length: 20,
                            length2: 80,
                            lineStyle: {
                                color: '#73c0de',
                            }
                        },
                        data: data
                    }
                ]
            };
            myChart.clear();
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 24rem;
    // height: 13.5rem;
    min-height: 100vh;
    margin: 0 auto;
    // position: relative;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // background-color: #030E27;
    background: url('../../assets/yq/bg.png');
    background-size: 100% 100%;

    .head {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 1.2rem;
        background: url('../../assets/yq/headbg.png');
        background-size: 100% 100%;
        font-size: 0.55rem;
        font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
        font-weight: 700;
        color: #19ECFF;
        letter-spacing: 5px;
    }

    .content {
        display: flex;
        width: 100%;
        // height: 12.25rem;
        margin: .43rem auto 0;
        padding: 0 .39rem .43rem;

        .left {
            width: 5rem;
            display: flex;
            flex-direction: column;

            .top {
                height: 5.63rem;
                // background: url('../../assets/yq/rectangle.png');
                // background-size: 100% 100%;

            }

            .img {}

            .footer {
                height: 5.5rem;
                margin-top: .39rem;
                flex: 1;
                // background: url('../../assets/yq/rectangle.png');
                // background-size: 100% 100%;
            }
        }



        .right {
            width: 17.83rem;
            margin-left: .38rem;

            // display: flex;
            // flex-direction: column;
            .top {
                position: relative;
                height: 8.37rem;

                .img {
                    animation-duration: 2s;
                    animation-direction: alternate;
                    animation-iteration-count: infinite;
                    position: absolute;
                    display: block;
                    width: .5rem;
                    height: 1.27rem;
                    cursor: pointer;
                    padding: 0 .2rem;
                    box-sizing: content-box;
                }

                .img:nth-child(odd) {
                    animation-name: FadeIn;

                }

                .img:nth-child(even) {
                    animation-name: FadeIn1;

                }

                .img:nth-of-type(3n) {
                    animation-name: FadeIn;

                }

                .img:hover {
                    transform: scale3d(1.1, 1.1, 1.1);
                    animation-name: none;
                }

                .info-line {
                    display: flex;
                    margin-top: .25rem;

                    .info:focus,
                    .info:hover {
                        transform: scale3d(1.1, 1.1, 1.1)
                    }

                    .info {
                        display: flex;
                        align-items: center;
                        cursor: pointer;

                        .text {
                            display: flex;
                            flex-direction: column;
                            margin-left: .2rem;

                            .t-t {
                                display: flex;
                                align-items: center;
                                font-size: 0.25rem;
                                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                                font-weight: 500;
                                color: #FFFFFF;

                                img {
                                    margin-left: .1rem;
                                    cursor: pointer;
                                }
                            }

                            .t-b {
                                display: flex;
                                align-items: baseline;
                                margin-top: .3rem;
                                font-size: 0.63rem;
                                font-family: Impact-Regular, Impact;
                                font-weight: 400;
                                color: #FFF200;

                                span:nth-child(2) {
                                    margin-left: .23rem;
                                    font-size: 0.25rem;
                                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                                    font-weight: 400;
                                    color: #FFFFFF;
                                }
                            }
                        }
                    }
                }
            }

            .footer {
                height: 3.13rem;
                display: flex;

                .f-l {
                    width: 12.45rem;
                    height: 100%;
                    // background: url('../../assets/yq/rectangle3.png');
                    // background-size: 100% 100%;
                }

                .f-r {
                    width: 5rem;
                    height: 100%;
                    margin-left: .38rem;
                    // background: url('../../assets/yq/rectangle2.png');
                    // background-size: 100% 100%;
                }
            }

        }
    }
}

@keyframes FadeIn {
    0% {
        transform: rotateY(5deg);
    }

    20% {
        transform: rotateY(65deg);
    }

    60% {
        transform: rotateY(130deg);
    }

    100% {
        transform: rotateY(185deg);
    }

}

@keyframes FadeIn1 {

    0% {
        transform: rotateY(65deg);
    }

    20% {
        transform: rotateY(130deg);
    }

    60% {
        transform: rotateY(185deg);
    }

    100% {
        transform: rotateY(5deg);
    }

}
</style>
<style lang="scss">
.partner {

    .partner .dv-digital-flop canvas {
        text-align: left !important;
        width: 80% !important;
        height: 80% !important;
    }

    // .dv-digital-flop canvas {
    //     width: 80% !important;
    //     height: 80% !important;
    //     margin-left: .2rem !important;
    // }

    .active-ring-name {
        font-size: .23rem !important;
        padding-top: .1rem;
    }

    // .el-select > .el-input{
    //     width: auto;
    // }
    .el-input__inner {
        // width: 2.79rem;
        height: 0.38rem;
        background: rgba(0, 224, 219, 0.08) !important;
        border: 0.01rem solid rgba(25, 236, 255, 0.4);
        border-radius: 0.03rem;
        color: #FFFFFF !important;
        font-size: .13rem !important;
    }

    .el-input__icon {
        color: #00E0DB;
    }

    .el-select .el-input .el-select__caret {
        color: #00E0DB !important;
        line-height: inherit;

    }

    .search_input>.el-input__inner {
        // padding: 0 0 0 .4rem;
        width: 3.23rem !important;
    }

    .header {
        background: rgba(0, 224, 219, 0.08) !important;
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #19ECFF;

    }

    // DataV
    .header-item {
        font-size: .175rem !important;
        opacity: .85;
    }

    .rows {
        // height: 3.5rem!important;
        padding: .15rem 0 .3rem 0;
    }

    .row-item {
        background: transparent !important;

        div:nth-child(7) {
            span {
                // margin-left: .6rem !important;
            }
        }
    }

    .row-item:hover {
        background-color: rgba(255, 255, 255, 0.05) !important;
    }

    .ceil {
        font-size: .15rem !important;
    }

    .ceil:first-child {
        // color: #FFC300;
    }

    // 排名轮播
    .dv-scroll-ranking-board .ranking-column {
        height: 0.15rem;
        background: #102c41;
        border: none;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-top: 5px;
    }

    .dv-scroll-ranking-board .ranking-column .inside-column {
        width: 5.5rem;
        height: 0.15rem;
        background: linear-gradient(270deg, #FFE11D 0%, #00E0DB 100%) !important;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-bottom: 0;
        overflow: hidden;
    }

    .dv-scroll-ranking-board .ranking-column .shine {
        background-color: transparent !important;
        animation: none !important;
    }

    .dv-scroll-ranking-board .ranking-info .rank {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .dv-scroll-ranking-board .ranking-info .info-name {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .ranking-value {
        font-size: 0.15rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #FFE11D;
    }

    .dv-water-pond-level canvas {
        border: 1px solid #21EEE9;
        margin-left: .09rem;
        margin-top: .09rem;
    }

    .dv-water-pond-level text {
        font-size: 0.23rem !important;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN !important;
        font-weight: 500 !important;
        color: #010E26 !important;
        opacity: 0 !important;

    }

}

@media only screen and (max-width: 1900px) {
    .header {
        width: 100%;
    }

    .header-item {
        font-size: 8px !important;
    }

    .header-item:last-child {
        // width: 2.5rem !important;
        // background: #013346;
        // opacity: 1;
    }

    .dv-digital-flop,
    .active-ring-name {
        font-size: 12px !important;
    }
}</style>